import React from 'react';
import { Data } from '../../types';
import * as LocationManager from '../domain/location-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { useData, RefreshDataFunction } from './DataProviderCache';

type ContextState = {
    refreshData: RefreshDataFunction;
    dataset: Array<Data<{
        organizationId: string;
        organizationName: string;
        address: string;
        locations: Array<{
            locationId: string;
            locationName: string;
            address: string;
            displayOrder: number;
            siteCount: number;
            status: string;
        }>;
    }>>;
}
const Context = React.createContext<ContextState | null>(null);

function useLocationListData(): ContextState['dataset'] {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useLocationListData must be used within a OrgLocationListDataProvider');
    }
    return contextState.dataset;
}

function useLocationRefreshData(): ContextState['refreshData'] {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useLocationListData must be used within a OrgLocationListDataProvider');
    }
    return contextState.refreshData;
}
const LocationListDataProvider: React.FC<{ organizationId: string; userId: string; operation: string }> = (props) => {
    const authHelper = useAuthHelper();
    const dataObj = useData({
        cacheKey: 'location-list-data',
        id: props.organizationId,
        dataFn: React.useCallback(
            () => LocationManager.getLocations(authHelper, {
                organizationId: props.organizationId,
                userId: props.userId,
                operation: props.operation
            }),
            [authHelper, props.organizationId, props.userId, props.operation]
        ),
    });

    return <Context.Provider value={dataObj}>{props.children}</Context.Provider>;
};
const TestLocationListDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);
export { LocationListDataProvider, TestLocationListDataProvider, useLocationListData, useLocationRefreshData };
